<template>
  <div v-loading="loading" class="dashboard-root main-content u-p4">
    <ba-header active-module="Enrolled Users"></ba-header>
    <h2 class="c-heading__page u-mt4 u-pt2 u-pb3">Enrolled Users ({{enrolledUsersCount}})</h2>
    <h2 class="u-text--center u-header-padding"> {{companyNameById(companyId)}}</h2>
    <div class="u-text--sm u-text--center">Welcome {{user.username}}</div>

    <el-form label-position="left" class="u-mt4" @submit.native.prevent>
      <el-row>
        <el-col>
          <el-form-item class="search-users-form" label="Search">
            <div class="display-flex">
              <el-input v-model="stringLookupInput" @keyup.enter.native="applyFilters">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                <i slot="suffix" class="el-input__icon el-icon-close u-link" @click="stringLookupInput = ''"></i>
              </el-input>
              <el-popover
                  placement="bottom"
                  trigger="hover"
                  popper-class="search-in-policy-popover"
                  content="Text lookup will include Policy Numbers. If activated, this may slow down the search/pagination."
                  :open-delay="500">
                <div slot="reference">
                  <el-checkbox v-model="searchByPolicyNumber" class="u-ml4">Search by Policy Numbers</el-checkbox>
                </div>
              </el-popover>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div v-if="isUsersListDownloaded" class="block date-filter">
      <span class="date-from">From</span>
      <el-date-picker
              v-model="pickerDateFrom"
              type="date"
              placeholder="Pick a date"
              format="MM/dd/yyyy">
      </el-date-picker>
      <span>To</span>
      <el-date-picker
              v-model="pickerDateTo"
              type="date"
              placeholder="Pick a date"
              format="MM/dd/yyyy">
      </el-date-picker>
      <el-button icon="el-icon-search" @click="applyFilters">Filter</el-button>
      <el-button v-if="pickerDateFrom || pickerDateTo || stringLookupInput" @click="resetFilter">
        Clear Filter
      </el-button>
    </div>
    <div class="download-users u-mt3">
      <el-button v-if="enrolledUsersCount<1000" @click="downloadInsuredListXls">Download Enrolled User List</el-button>
      <el-button v-else @click="performSendInsuredListOnEmail">Send Enrolled Users List via Email</el-button>
    </div>

    <el-table
              v-if="isUsersListDownloaded"
              class="users-table u-mt4 u-mb4"
              :row-class-name="userTableRowClassName"
              :data="retrievedUsersData.items"
              :default-sort="{prop: 'registered_date', order: 'descending'}"
              ref="usersTable"
              @sort-change="sortChange">
      <el-table-column
              label="Name"
              class-name="overflow-data"
              prop="name"
              sortable="custom"
              >
        <template slot-scope="scope">
          <el-popover
              v-if="user.superuser_login"
              placement="top-start"
              trigger="hover"
              :open-delay="1000">
            <div slot="default">
              user id: {{scope.row.user_id}}
            </div>
            <div slot="reference">
              {{scope.row.name}}
            </div>
          </el-popover>

          <span v-else>{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column
              label="User Login"
              class-name="overflow-data"
              prop="username"
              sortable="custom"
              :render-header="renderUsernameHeader">
        <template slot-scope="scope">
          <div>
            <span>
              {{scope.row.username}}
            </span>
            <icon class="u-mr1 auto_enroll__icon" v-if="scope.row.auto_enrolled" slot="reference" scale=".5" :name="'star'"></icon>
          </div>
        </template>              
      </el-table-column>
      <el-table-column
              label="Registration Date"
              class-name="centered-break-all"
              prop="registered_date"
              width="175"
              sortable="custom">
      </el-table-column>
      <el-table-column
              label="eDelivery"
              class-name="centered-break-all"
              prop="edelivery"
              sortable="custom"
              width="120">
      </el-table-column>
      <el-table-column
              label="BriteCore Contacts"
              class-name="centered-break-all"
              width="100"
              prop="subaccounts_quantity">
      </el-table-column>
      <el-table-column
              label="Actions"
              width="100">
        <template slot-scope="scope">
          <el-dropdown trigger="click">
            <el-button size="mini">
              More<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item  @click.native="sendInsuredMessage(scope.row.user_id)">Send Message to User</el-dropdown-item>
              <el-dropdown-item v-if="user.superuser_login" @click.native="getSuperuserCredentialsClick(scope.row.user_id)">Impersonate User</el-dropdown-item>
              <el-dropdown-item v-if="user.superuser_login" @click.native="deleteUser(scope.row)">Delete User</el-dropdown-item>
              <el-dropdown-item v-if="user.is_superuser" @click.native="manageContact(scope.row)">Manage Contact</el-dropdown-item>
              <el-dropdown-item @click.native="showPolicyInformationClick(scope.row.user_id)">Policy Information</el-dropdown-item>
              <el-dropdown-item v-if="scope.row.blocked" @click.native="unblockUserclick(scope.row.user_id)">Unblock</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :layout="paginationLayout"
                   :total="retrievedUsersData.total"
                   :page-size="perPage"
                   :current-page.sync="appliedFilter.page"
                   @current-change="loadInsureds">
    </el-pagination>
    <el-dialog
            title="Impersonate User"
            :visible.sync="loginAsSuperuserDialog.visible"
            custom-class="creds-dialog"
            :close-on-click-modal="false">
      <div class="word-break--word u-text--left">
        <p>
          <i v-if="getSetting('global.application_versions_supported')==='version_mobile_only'">
            This is a one-time password to perform superuser access to given user. Password will expire automatically within 30 minutes.
          </i>
          <i v-else>
            To login to the web app automatically you can use the button below.  If you want to log in to the mobile version you will need to copy the credentials below.
          </i>
        </p>
        <div class="u-mt1">
          <div class="cut-long-text creds-text">
            <span><b>Username:</b> {{loginAsSuperuserDialog.userName}}</span>
          </div>
          <div class="display-inline">
            <el-tooltip class="item" effect="dark" content="Copy" placement="top-start" :enterable="false">
              <el-button type="text"
                         icon="el-icon-copy-document"
                         class="copy-creds-button"
                         @click="copyToClipboard(loginAsSuperuserDialog.userName)">
              </el-button>
            </el-tooltip>
          </div>
        </div>

        <div class="u-mt1">
          <div class="cut-long-text creds-text">
            <span><b>Password:</b> {{loginAsSuperuserDialog.password}}</span>
          </div>
          <div class="display-inline">
            <el-tooltip class="item" effect="dark" content="Copy" placement="top-start" :enterable="false">
              <el-button type="text"
                         icon="el-icon-copy-document"
                         class="copy-creds-button"
                         @click="copyToClipboard(loginAsSuperuserDialog.password)">
              </el-button>
            </el-tooltip>
          </div>
        </div>

        <div class="u-mt3 display-flex">
            <el-button type="success" @click="openWebSite" class="u-mra" size="small"
                       v-if="getSetting('global.application_versions_supported')!=='version_mobile_only'">
              Login Automatically
            </el-button>
            <el-button type="primary" @click="loginAsSuperuserDialog.visible=false" class="u-mla" size="small">
              OK
            </el-button>
        </div>

      </div>
    </el-dialog>

  </div>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex'
import iconUser from '../../assets/non-user.svg'
import config from '@/config'
import {createTableHeaderHelp} from '@/shared/api.utils'
import {convertDateToYYYYMMDD, emailRegex, copyToClipboard} from '@/shared/misc.utils'
import axios from 'axios'

export default {
  name: 'ba-dashboard',
  data () {
    let companyId = this.$route.params.companyId
    return {
      companyId,

      iconUser,
      isUsersListDownloaded: false,
      loading: false,
      pickerDateFrom: '',
      pickerDateTo: '',
      stringLookupInput: '',
      searchByPolicyNumber: false,
      retrievedUsersData: {},
      perPage: 20,
      appliedFilter: {
        page: 1,
        dateFrom: '',
        dateTo: '',
        searchString: '',
        searchByPolicyNumber: false,
      },
      enrolledUsersCount: null,
      loginAsSuperuserDialog: {
        visible: false,
        userName: '',
        password: '',
      },
    }
  },
  computed: {
    ...mapState('shared', ['user']),
    ...mapGetters('shared', ['companyNameById']),
    ...mapGetters('settings', ['getSetting']),
    paginationLayout () {
      let moreThan15Pages = this.retrievedUsersData &&
                            this.retrievedUsersData.num_pages &&
                            (this.retrievedUsersData.num_pages > 15)

      return moreThan15Pages ? 'prev, pager, next, jumper' : 'prev, pager, next'
    },
    isSuperuser () {
      return this.user ? this.user.is_superuser : false
    },
  },
  methods: {
    ...mapActions('shared', [
      'getInsureds', 'getSuperuserCredentials', 'deleteUserWithAllData',
      'getPolicyInformation', 'sendInsuredsListOnEmail', 'unblockUser']),
    userTableRowClassName ({row, rowIndex}) {
      return row.blocked ? 'blocked-user' : ''
    },
    async unblockUserclick (userId) {
      await this.unblockUser(userId)
      await this.loadInsureds()
    },
    async getUrl () {
      let url = config.url + `/company/${this.companyId}/builds/version/desktop/`
      let response = await axios.get(url)
      return response.data.url
    },
    async openWebSite () {
      let url = `${await this.getUrl()}/#/dashboard?` +
        `username=${encodeURIComponent(this.loginAsSuperuserDialog.userName)}&` +
        `password=${encodeURIComponent(this.loginAsSuperuserDialog.password)}`
      window.open(url, '_blank')
    },
    copyToClipboard (value) {
      copyToClipboard(value)
    },
    downloadInsuredListXls () {
      let url = `${config.url}/company/${this.companyId}/get_insureds_xls/?token=${localStorage.carrierToken}`
      window.open(url, '_blank')
    },
    async performSendInsuredListOnEmail () {
      let username = this.user.username
      let initInputValue = emailRegex.test(username) ? username : ''
      let emailTo = ''
      try {
        let result = await this.$prompt(
          'This list is very large. We will create the list and send it to you via email.',
          initInputValue ? 'Please enter or change the email.' : 'Please enter the email.',
          {
            confirmButtonText: 'Send',
            cancelButtonText: 'Cancel',
            inputPattern: emailRegex,
            inputErrorMessage: 'Invalid Email',
            inputValue: initInputValue,
          }
        )
        emailTo = result.value
      } catch (e) {
        // user pressed cancel
        return
      }
      try {
        await this.sendInsuredsListOnEmail({
          companyId: this.companyId,
          email_to: emailTo
        })
        this.$notify({
          title: 'Processing',
          message: `The Enrolled User List will be sent soon to ${emailTo}`,
          type: 'success'
        })
      } catch (e) {
        this.$message({
          type: 'error',
          message: `Failed to request insureds list. ${e.response.message}`
        })
      }
    },
    sendInsuredMessage (insuredId) {
      this.$router.push({name: 'send-insured-message', query: {insuredId: insuredId}})
    },
    manageContact (user) {
      this.$router.push({name: 'manage-contact', query: {user_id: user.user_id}})
    },
    async deleteUser (user) {
      if (!user.username) {
        return
      }

      try {
        await this.$confirm(
          'This will remove the user and all associated data with it. Are you sure you want to do this?',
          `Deleting user ${user.username}?`,
          {
            confirmButtonText: 'Delete User',
            cancelButtonText: 'Cancel',
            type: 'warning'
          })
      } catch (e) {
        return
      }

      try {
        await this.deleteUserWithAllData({username: user.username, company_id: this.companyId})
      } catch (e) {
        this.$message({
          type: 'error',
          message: `Failed to remove user. ${e.response.message}`
        })
        return
      }

      this.$message({
        type: 'success',
        message: 'Delete completed'
      })

      await this.loadInsureds()
    },
    async getSuperuserCredentialsClick (userId) {
      try {
        let result = await this.getSuperuserCredentials(userId)
        this.loginAsSuperuserDialog.userName = result.data.username
        this.loginAsSuperuserDialog.password = result.data.password
        this.loginAsSuperuserDialog.visible = true
      } catch (error) {
        this.$message({
          type: 'error',
          message: `Failed to request insureds list. ${error.response.message}`
        })
      }
    },
    policyLine (policy) {
      return '<p class="u-ml3">' + policy.policy_type + ': <b>' + policy.policy_number + '</b></p>'
    },
    showPolicyInformationClick (userId) {
      this.getPolicyInformation({companyId: this.companyId, userId: userId})
        .then(response => {
          if (response.data.success) {
            let output = '<p><b><i>Active</i></b> policies associated with this account:</p>'
            response.data.active.forEach((policy) => {
              output += this.policyLine(policy)
            })

            if (response.data.canceled.length) {
              output += '<br><p><b><i>Cancelled</i></b> policies associated with this account:</p>'
              response.data.canceled.forEach((policy) => {
                output += this.policyLine(policy)
              })
            }

            if (!response.data.active.length && !response.data.canceled.length) {
              output = '<p>There are no policies associated with the account.'
            }

            this.$alert(
              output,
              'Policy Information',
              {
                dangerouslyUseHTMLString: true,
                customClass: 'policy_info_scroll'
              }
            )
          }
        })
    },
    sortChange (sortProperties) {
      let column = sortProperties.column
      if (column.order === null) {
        this.$refs.usersTable.sort(column.property, 'descending')
        return
      }
      let columnName = {
        'Registration Date': 'date_joined',
        'Name': 'name',
        'User Login': 'username',
        'eDelivery': 'edelivery'
      }[column.label]

      this.orderBy = column.order === 'descending' ? '-' + columnName : columnName
      this.appliedFilter.page = 1
      this.loadInsureds()
    },
    resetFilter () {
      this.pickerDateFrom = ''
      this.pickerDateTo = ''
      this.stringLookupInput = ''
      this.applyFilters()
    },
    applyFilters () {
      this.appliedFilter.page = 1
      this.appliedFilter.dateFrom = this.pickerDateFrom
      this.appliedFilter.dateTo = this.pickerDateTo
      this.stringLookupInput = this.stringLookupInput.trim()
      this.appliedFilter.searchString = this.stringLookupInput
      this.appliedFilter.searchByPolicyNumber = this.searchByPolicyNumber
      this.loadInsureds()
    },
    async loadInsureds () {
      this.loading = true
      let callParams = {
        companyId: this.companyId,
        page_size: this.perPage,
        page: this.appliedFilter.page,
        order_by: this.orderBy,
      }
      if (this.appliedFilter.dateFrom) {
        callParams.from_date = convertDateToYYYYMMDD(this.appliedFilter.dateFrom)
      }
      if (this.appliedFilter.dateTo) {
        callParams.to_date = convertDateToYYYYMMDD(this.appliedFilter.dateTo)
      }
      if (this.appliedFilter.searchString) {
        callParams.searchstring = this.appliedFilter.searchString
        if (this.appliedFilter.searchByPolicyNumber) {
          callParams.search_by_policy_number = true
        }
      }
      try {
        let result = await this.getInsureds(callParams)
        this.isUsersListDownloaded = true
        this.retrievedUsersData = result.search_result
        this.enrolledUsersCount = result.enrolled_users_count
      } catch (e) {
        this.isUsersListDownloaded = false
        this.$message({
          type: 'error',
          message: `Failed to load users. ${e.response.message}`
        })
      }
      this.loading = false
    },
    renderUsernameHeader (h, { column, $index }) {
      let txt = 'Entries with a star indicate the user was auto-enrolled.'
      return createTableHeaderHelp(h, column.label, txt, 'hover', 'top', 240)
    }
  },
  mounted () {
    this.loadInsureds()
  }
}
</script>
<style lang="scss">

  @import '../../styles/variables';

  .search-in-policy-popover {
    width: 400px;
    background-color: black;
    color: white;
  }

  .users-table {
    width: auto !important;
  }
  .date-from {
    padding-right: 39px;
  }

  .overflow-data > div.cell, .overflow-data > div.cell .el-popover__reference {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .overflow-data:hover > div.cell, .overflow-data:hover > div.cell  .el-popover__reference{
    overflow: visible;
    white-space: normal;
    height: auto;
}

  .centered-break-all > div.cell {
    word-break: keep-all;
    text-align: center;
  }

  .download-users {
    overflow: hidden;
    margin-bottom: -20px;
  }

  .download-users > button {
    float: right;
  }

  .search-users-form {
    max-width: 1000px;

    & > .el-form-item__label {
      width: 70px;
      font-weight: 400;
      font-size: 16px;
      color: #142324;
    }
    @media only screen and (max-width: 992px) {
      width: 100%;
      padding-right: 1rem;
    }
  }

  .date-filter > button {
    vertical-align: top;
    margin-left: 5px;
  }

  .el-table .warning-row {
    background: oldlace;
  }

  .policy_info_scroll {
    overflow: auto !important;
    max-height: 500px;
  }

</style>

<style lang="css" scoped>

  div >>> .copy-creds-button {
    float: right;
    padding: 0;
  }
  div >>> .creds-dialog {
    width: 420px;
    margin: auto !important;
    height: fit-content;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  div >>> .creds-text {
    width: 95%;
    display: inline-block
  }

  div >>> .creds-dialog .el-dialog__body {
    padding: 10px 15px !important;
  }

  div >>> .creds-dialog .el-dialog__header {
    text-align: left;
    padding: 10px 15px !important;
  }

  div >>> .creds-dialog .el-dialog__headerbtn {
    top: 13px !important;
  }

  div >>> .blocked-user {
    background-color: red;
  }


</style>
